"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _crud = require("@crud/crud");

//
//
//
//
//
//
//
var _default = {
  mixins: [(0, _crud.crud)()],
  props: {
    itemClass: {
      type: String,
      required: false,
      default: ''
    }
  }
};
exports.default = _default;